import ApiService from '../services/api'
import {
    StickerService,
} from '../services/stickers'


export const ACTIONS = {
    FETCH_STICKERS: 'fetchStickers',
    UPLOAD_STICKER: 'uploaderSticker',
    DEL_STICKER: 'delSticker',
    CLEAR_STICKERS: 'clearSticker',
    TOGGLE_STICKERS: 'toggleStickers',
}


export const MUTATIONS = {
    SET_STICKERS: 'setStickers',
    DEL_STICKER: 'delSticker',
    DISABLED_STICKER: 'disabledSticker',
    WAITING_NEW_STICKER: 'waitingNewSticker',
    CLEAR_STICKERS: 'clearSticker',
    TOGGLE_STICKERS: 'toggleStickers',
}


const state = {
    maxCount: 50,
    allStickers: [],
    allStickersIsLoading: true,
    disabledSticker: [],
    waitingNewSticker: false,
}


const getters = {
    maxCount: ({ maxCount }) => maxCount,
    allStickers: ({ allStickers }) => allStickers,
    allStickersIsLoading: ({ allStickersIsLoading }) => allStickersIsLoading,
    disabledSticker: ({ disabledSticker }) => disabledSticker,
    waitingNewSticker: ({ waitingNewSticker }) => waitingNewSticker,
}


const actions = {
    async [ACTIONS.FETCH_STICKERS]({ commit }) {
        const userId = window.user_id

        ApiService.setHeaderAuth()

        try {
            const { data } = await StickerService.getStickers(userId)
            commit(MUTATIONS.SET_STICKERS, data)
        } catch (error) {
            window.addStatusMessage('error', window.translateString('an_error_has_occurred._Please_try_again_in_a_few_minutes'))
            throw new Error(error)
        }
    },

    async [ACTIONS.UPLOAD_STICKER]({ commit }, file) {
        const STICKER_MAX_SIZE = 70 * 1000 * 1000

        if (file.size > STICKER_MAX_SIZE) {
            return window.addStatusMessage('error', window.translateString('file_manager_error_exceeded_max_size').format(70))
        }

        commit(MUTATIONS.WAITING_NEW_STICKER)

        const formData = new FormData()
        formData.append('file', file)

        ApiService.setHeaderAuth()

        try {
            const res = await StickerService.postStickers(formData)

            if (res.data.code) {
                window.addStatusMessage('error', res.data.message)
                commit(MUTATIONS.SET_STICKERS, {data: []})
            } else {
                commit(MUTATIONS.SET_STICKERS, {data: [res.data.data]})
            }
        } catch (error) {
            window.addStatusMessage('error', window.translateString('an_error_has_occurred._Please_try_again_in_a_few_minutes'))
            throw new Error(error)
        }
    },

    async [ACTIONS.DEL_STICKER]({ commit }, id) {
        commit(MUTATIONS.DISABLED_STICKER, [id])

        ApiService.setHeaderAuth()

        try {
            await StickerService.delStickers(id)
            commit(MUTATIONS.DEL_STICKER, id)
        } catch (error) {
            window.addStatusMessage('error', window.translateString('an_error_has_occurred._Please_try_again_in_a_few_minutes'))
            throw new Error(error)
        }
    },

    async [ACTIONS.CLEAR_STICKERS]({ commit }) {
        commit(MUTATIONS.CLEAR_STICKERS)
    },

    async [ACTIONS.TOGGLE_STICKERS]({ commit }, params) {
        commit(MUTATIONS.DISABLED_STICKER, params.stickers_ids)

        ApiService.setHeaderAuth()

        try {
            const { data } = await StickerService.putStickers(params)
            commit(MUTATIONS.TOGGLE_STICKERS, data)
        } catch (error) {
            window.addStatusMessage('error', window.translateString('an_error_has_occurred._Please_try_again_in_a_few_minutes'))
            throw new Error(error)
        }
    },
}


const mutations = {
    [MUTATIONS.SET_STICKERS](state, { data }) {
        state.allStickers.push(...data)
        state.allStickersIsLoading = false
        state.waitingNewSticker = false
    },

    [MUTATIONS.WAITING_NEW_STICKER](state) {
        state.waitingNewSticker = true
    },

    [MUTATIONS.DISABLED_STICKER](state, ids) {
        state.disabledSticker = [...state.disabledSticker, ...ids]
    },

    [MUTATIONS.DEL_STICKER](state, id) {
        state.allStickers = state.allStickers.filter(el => el.id !== id)
        state.disabledSticker = state.disabledSticker.filter(el => el !== id)
    },

    [MUTATIONS.CLEAR_STICKERS](state) {
        state.allStickers = []
        state.allStickersIsLoading = true
        state.disabledSticker = []
        state.waitingNewSticker = false
    },

    [MUTATIONS.TOGGLE_STICKERS](state, { data }) {
        // merge 2 arrays
        for (let i = 0, l = state.allStickers.length; i < l; i++) {
            for (let j = 0, ll = data.length; j < ll; j++) {
                if(state.allStickers[i].id === data[j].id) {
                    state.allStickers.splice(i, 1, data[j])
                    state.disabledSticker = state.disabledSticker.filter(el => el !== data[j].id)
                    break
                }
            }
        }
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
}